/**
 * React Query store pra aba 🔗 Relacionados (Bloco D.3).
 *
 * Hook único `useCardRelations(cardType, cardId)` consome
 * GET /api/v1/cards/:cardType/:cardId/relations.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from './api';

export type CardType = 'deal' | 'service_order';

export type RelationType =
  | 'criado_por_automacao'
  | 'criado_manualmente'
  | 'duplicado_de'
  | 'bloqueia'
  | 'relacionado_a';

export interface CardRelation {
  id: string;
  cardId: string;
  cardType: CardType;
  cardLabel: string;
  relationType: RelationType;
  automationRunId: string | null;
  criadoEmIso: string;
  context: Record<string, unknown>;
}

export interface CardRelationsResponse {
  children: CardRelation[];
  parents: CardRelation[];
}

export function useCardRelations(cardType: CardType, cardId: string) {
  return useQuery<CardRelationsResponse>({
    queryKey: ['card-relations', cardType, cardId],
    queryFn: () => api.get(`/api/v1/cards/${cardType}/${cardId}/relations`),
    enabled: Boolean(cardId),
    staleTime: 30_000,
  });
}

/**
 * FASE-C: cada tipo de relação vinha com um emoji (🤖 👤 📋 🚫 🔗) que era
 * renderizado como ícone na aba "Relacionados". O design system é Lucide-only
 * — o ícone agora é escolhido no componente e o campo `icon` saiu daqui.
 */
export const RELATION_TYPE_LABELS: Record<RelationType, { label: string }> = {
  criado_por_automacao: { label: 'Criado por automação' },
  criado_manualmente: { label: 'Criado manualmente' },
  duplicado_de: { label: 'Duplicado de' },
  bloqueia: { label: 'Bloqueia' },
  relacionado_a: { label: 'Relacionado' },
};
